import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import { ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

import { useIsWebviewHeadless } from '~/core/hooks/useIsWebview';
import { getEnvironmentAwareHref } from '~/core/utils';

import { DraftLink } from './styles';

type Props = {
    language: ShortCodeEnums.Language;
    showDraftCentralLink: boolean;
    showFullTrackerLink: boolean;
};

const DraftLinks: FC<Props> = ({ language, showDraftCentralLink, showFullTrackerLink }) => {
    const isWebview = useIsWebviewHeadless();

    return (
        <>
            {showFullTrackerLink && (
                <DraftLink href={getEnvironmentAwareHref('/draft/tracker', isWebview, language)}>
                    <FormattedMessage
                        description="Text indicating a link to the full draft tracker, a page listing all the selections for the draft"
                        defaultMessage="Full Tracker"
                    />
                </DraftLink>
            )}
            {showDraftCentralLink && (
                <DraftLink href={getEnvironmentAwareHref('/events/draft-coverage-central', false, language)}>
                    <FormattedMessage
                        description="Text indicating a link to the Draft Central page, a page which will contain all news and updates for the draft"
                        defaultMessage="Draft Central"
                    />
                </DraftLink>
            )}
        </>
    );
};

export default DraftLinks;
